import { render, staticRenderFns } from "./MoreGroups.vue?vue&type=template&id=25549c0d&scoped=true&"
import script from "./MoreGroups.vue?vue&type=script&lang=js&"
export * from "./MoreGroups.vue?vue&type=script&lang=js&"
import style0 from "./MoreGroups.vue?vue&type=style&index=0&id=25549c0d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25549c0d",
  null
  
)

export default component.exports